import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "../lib/api";
import { SectionTitle, Loading, Card, Pill } from "../components/common";
import { AdSlot } from "../components/AdSlot";
import { NewsWire } from "../components/NewsWire";

// Temporary in-house adverts (link out). Google AdSense gets priority if it fills the slot.
const LINGUISTIC_AD = {
  href: "https://www.linguisticquest.com",
  img: "https://customer-assets-v7afamib.emergentagent.net/job_dynamos-portal/artifacts/v93n98yj_Screenshot%202026-09-14%20at%2009.33.32.png",
  alt: "Linguistic Quest — language puzzles for kids",
  testid: "house-ad-linguisticquest",
};
const TSORO_AD = {
  href: "https://www.playtsoro.com",
  img: "https://customer-assets-v7afamib.emergentagent.net/job_dynamos-portal/artifacts/hd6cf453_Screenshot%202026-09-14%20at%2009.32.59.png",
  alt: "Play Tsoro — the Zimbabwean strategy board game",
  testid: "house-ad-playtsoro",
};

const META = {
  news: { kicker: "Reverse chronology", title: "News feed", desk: "Tendai Moyo" },
  articles: { kicker: "Long-form", title: "Articles & Features", desk: "Chipo Ncube" },
  updates: { kicker: "Breaking · Official", title: "Updates", desk: "Farai Dube" },
};

export default function FeedPage({ type }) {
  const [stories, setStories] = useState(null);
  useEffect(() => { setStories(null); client.get(`/stories?type=${type}`).then((r) => setStories(r.data)).catch(() => setStories([])); }, [type]);
  if (stories === null) return <Loading />;
  const m = META[type];
  return (
    <div data-testid={`feed-${type}`}>
      <div className="flex items-end justify-between flex-wrap gap-2">
        <SectionTitle kicker={m.kicker}>{m.title}</SectionTitle>
        <span className="text-sm text-ink/50 mb-5">Desk: <span className="font-semibold text-green">{m.desk}</span></span>
      </div>
      {type === "news" && <div className="mb-6"><AdSlot id="news.top" height={140} house={LINGUISTIC_AD} /></div>}
      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 grid sm:grid-cols-2 gap-4">
          {stories.length === 0 && <p className="text-ink/50">No stories yet.</p>}
          {stories.map((s, i) => (
            <React.Fragment key={s.id}>
              <Link to={`/${type}/${s.slug}`}>
                <Card className="overflow-hidden h-full hover:-translate-y-1 transition-transform">
                  {s.hero_image && <img src={s.hero_image} alt={s.title} className="w-full h-40 object-cover" />}
                  <div className="p-4">
                    <div className="flex items-center gap-1.5">
                      <Pill tone="muted">{type}</Pill>
                      {s.opinion && <Pill tone="live">Opinion</Pill>}
                    </div>
                    <h3 className="font-head font-bold text-green mt-2 leading-snug">{s.title}</h3>
                    <p className="text-sm text-ink/60 mt-2 line-clamp-2">{s.body?.slice(0, 120)}…</p>
                    <p className="text-xs text-ink/40 mt-3">{s.author} · {new Date(s.created_at).toLocaleDateString("en-GB")}</p>
                  </div>
                </Card>
              </Link>
              {i === 1 && <div className="sm:col-span-2"><AdSlot id="editorial.infeed" height={90} /></div>}
            </React.Fragment>
          ))}
        </div>
        <div className="space-y-6">
          {type === "news" && <NewsWire />}
          <AdSlot id="editorial.infeed" height={300} />
        </div>
      </div>
      {type === "news" && <div className="mt-8"><AdSlot id="news.bottom" height={140} house={TSORO_AD} /></div>}
    </div>
  );
}
